import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { api } from '@/lib/api';
import { UserSearch } from 'lucide-react';

// V5.0 §12 — employees matched to formal positions still without an
// applicable competency evaluation (operational follow-up, never fabricated).
export const PendingGapsCard = ({ t }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/client/talent-competency/gap-analysis')
      .then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  const pending = (data?.users || []).filter((u) => u.state === 'no_evaluation');
  if (!data) return null;
  return (
    <Card className="p-5 shadow-card" data-testid="tco-pending-gaps-card">
      <div className="flex items-center gap-2 mb-1">
        <UserSearch className="h-5 w-5 text-amber-600" />
        <h2 className="font-semibold">
          {t('tco.pendingGaps.title', { defaultValue: 'Evaluaciones de competencias pendientes' })}
        </h2>
        <Badge variant="outline" className="text-xs">{pending.length}</Badge>
      </div>
      <p className="text-xs text-muted-foreground mb-3">
        {t('tco.pendingGaps.subtitle', { defaultValue: 'Colaboradores vinculados a puestos formales que aún no cuentan con una evaluación aplicable. Seguimiento operativo — los resultados nunca se generan automáticamente.' })}
      </p>
      {pending.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="tco-pending-gaps-empty">
          {t('tco.pendingGaps.empty', { defaultValue: 'Sin pendientes: todos los colaboradores vinculados tienen evaluación.' })}
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-2">
          {pending.map((u) => (
            <div key={u.user?.id || u.user_id} className="rounded-md border bg-muted/20 px-3 py-2 text-sm"
                 data-testid={`tco-pending-gap-${u.user?.id || u.user_id}`}>
              <p className="font-medium">{u.user?.name || u.name}</p>
              <p className="text-xs text-muted-foreground">
                {(u.matched_position?.position_title) || u.position || '—'}
                {' · '}{(u.competencies || []).length}{' '}
                {t('tco.pendingGaps.required', { defaultValue: 'competencias requeridas' })}
              </p>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
